import { createSlice } from '@reduxjs/toolkit';

export const cartItemsSlice = createSlice({
	name: 'cartItems',
	initialState: {
		data: [],
	},
	reducers: {
		setCartItems: function (state, action) {
			state.data = action.payload;
		},

		addCartItems: function (state, action) {
			action.payload.forEach((newItem) => {
				const existingIndex = state.data.findIndex(item => item.item_code === newItem.item_code);
				if (existingIndex !== -1) {
					// If item exists, we update the quantity (ensuring it's treated as a number)
					const existingItem = state.data[existingIndex];
					state.data[existingIndex] = {
						...existingItem,
						quantity: (parseInt(existingItem.quantity) || 0) + (parseInt(newItem.quantity) || 1)
					};
				} else {
					// If item doesn't exist, we add it
					state.data.push(newItem);
				}
			});
		},

		updateCartItem: function (state, action) {
			state.data[state.data.findIndex(item => item.item_code === action.payload.item_code)] = action.payload;
		},

		removeCartItem: function (state, action) {
			state.data = state.data.filter(item => item.item_code !== action.payload);
		},
	},
});

export const { setCartItems, addCartItems, updateCartItem, removeCartItem } = cartItemsSlice.actions;
export default cartItemsSlice.reducer;
